export default {
  name: 'es',
  data: {
    modal: {
      cancel: 'Cancelar',
      confirm: 'Confirmar'
    },
    pagination: {
      prev: 'Anterior',
      next: 'Siguiente'
    },
    select: {
      empty: 'Sin Datos... \\[ o_x ]/'
    },
    table: {
      empty: 'Sin Datos... \\[ o_x ]/'
    }
  }
}